import React, { Component } from "react";

const colourStyles = {
  input: (styles) => ({
    ...styles,
    color: "#fff",
  }),
  singleValue: (base) => ({
    ...base,
    color: "#fff",
  }),
  control: (styles) => ({
    ...styles,
    backgroundColor: "#6F6F6F",
    color: "#fff",
  }),
  placeholder: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
    };
  },
  dropdownIndicator: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
    };
  },
  noOptionsMessage: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
      backgroundColor: "#000",
    };
  },
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "#1c4d85" : isFocused ? "#1978E2" : "#000",
      color: "#FFF",
      cursor: isDisabled ? "not-allowed" : "default",
      "&:hover": {
        backgroundColor: "#1978E2",
      },
    };
  },
};

const styles = {
  root: {
    color: "#2CBDD7",
  },
};

const hiddenFileInput = React.createRef(null);
const hiddenFileInput_r = React.createRef(null);

class ModalSancionRegente extends Component {
  render() {
    return (
      <>
        <div>
          <fieldset className="panel">
            <legend>Sanción</legend>
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="form-group">
                    <label htmlFor="regente">
                      Seleccione regente:{" "}
                      <span className="text-danger"> *</span>
                    </label>
                    <select
                      name="regente_id"
                      id="regente_id"
                      onChange={(e) => this.props.component.handleRegente(e)}
                      value={this.props.state.regente_id}
                      className="form-control"
                    >
                      <option value="">Seleccione</option>
                      {this.props.state.opciones_regente.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.nombre} [{option.folio_regente}]
                        </option>
                      ))}
                    </select>
                    <hr></hr>
                    <div className="table-responsive">
                      <table className="table table-striped m-b-0 table-hover">
                        <thead>
                          <tr>
                            <th>Establecimiento(s)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.props.state.establecimientos_ligados.length >
                          0 ? (
                            this.props.state.establecimientos_ligados.map(
                              (establecimientos, index) => (
                                <tr key={index} id={index}>
                                  <td>{establecimientos.razon_social}</td>
                                </tr>
                              )
                            )
                          ) : (
                            <tr>
                              <td className="text-center">
                                No se hay establecimientos
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    <hr></hr>
                    <label htmlFor="sancion">
                      Tipo sanción: <span className="text-danger"> *</span>
                    </label>
                    <select
                      name="tipo_sancion"
                      id="tipo_sancion"
                      onChange={(e) =>
                        this.props.component.handleTipoSancionChange(e)
                      }
                      value={this.props.state.tipo_sancion_id}
                      className="form-control"
                    >
                      <option value="">Seleccione</option>
                      {this.props.state.opciones_sancion.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.descripcion}
                        </option>
                      ))}
                    </select>
                    <label htmlFor="infraccion">
                      Tipo infracción: <span className="text-danger"> *</span>
                    </label>
                    <select
                      name="tipo_infraccion"
                      id="tipo_infraccion"
                      onChange={(e) => this.props.component.handleInfraccion(e)}
                      value={this.props.state.tipo_infraccion_id}
                      className="form-control"
                    >
                      <option value="0">Seleccione infracción</option>
                      {this.props.state.opciones_infraccion.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.descripcion}
                        </option>
                      ))}
                    </select>
                    <label htmlFor="causa_sancion">
                      Causa sanción: <span className="text-danger"> *</span>
                    </label>
                    {/*
                    <Select
                      isMulti
                      id="causa_sancion"
                      name="causaSancion"
                      styles={colourStyles}
                      placeholder="Seleccione"
                      theme="neutral40"
                      defaultValue={this.props.state.causas_sancion}
                      value={this.props.state.causas_sancion}
                      onChange={(e) =>
                        this.props.component.handleCausasChange(e)
                      }
                      options={this.props.state.opciones_causas}
                      getOptionLabel={(causa) => causa.descripcion}
                      getOptionValue={(causa) => causa.id}
                      noOptionsMessage={() =>
                        "No se encontraron causas de sanción"
                      }
                    />*/}
                    <textarea
                      className="form-control"
                      placeholder="Causa de la sanción"
                      maxLength={1000}
                      rows="5"
                      name="causas_sancion"
                      value={this.props.state.causas_sancion}
                      onChange={(e) =>
                        this.props.component.handleCausasChange(e)
                      }
                    ></textarea>
                    <div
                      className="invalid-feedback"
                      style={{ display: "none" }}
                      id="causas-error"
                    ></div>
                    {this.props.state.tipo_sancion_id === "1" ? (
                      <div>
                        <label htmlFor="monto">Monto:</label>
                        <input
                          type="text"
                          value={this.props.state.monto}
                          name="monto"
                          pattern="[0-9]{0,7}" //expresion que solo permite numeros de tam 7
                          onChange={(e) =>
                            this.props.component.handleMontoChange(e)
                          }
                          className="form-control"
                          id="monto"
                          title="Monto"
                          placeholder="Monto en córdoba"
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="monto-error"
                        ></div>
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="col-lg-10">
                  <div className="form-group">
                    <label htmlFor="documentp_1">
                      <span className="text-danger">
                        Solo se aceptan archivos ".pdf"*
                      </span>
                    </label>
                    <input
                      name="informe_inspector"
                      type="text"
                      disabled={true}
                      //defaultValue="Subir informe inspector"
                      value={this.props.state.nom_informe}
                      className="form-control m-b-5"
                      placeholder="Subir informe inspector"
                    ></input>
                  </div>
                </div>
                <div className="col-md-2" style={{ marginTop: "1.7%" }}>
                  <div className="form-group">
                    <button
                      type="button"
                      name="b_informe_inspector"
                      className="btn btn-primary float-right"
                      onClick={(e) => hiddenFileInput.current.click()}
                    >
                      Seleccionar archivo
                    </button>
                    <input
                      type="file"
                      accept=".pdf"
                      ref={hiddenFileInput}
                      name="b_informe_inspector"
                      onChange={(e) => {
                        this.props.component.handleFile(1, e.target);
                        
                      }}
                      style={{ display: "none" }}
                    />
                  </div>
                </div>
                <div className="col-lg-10">
                  <div className="form-group">
                    <label htmlFor="documentp_1">
                      <span className="text-danger">
                        Solo se aceptan archivos ".pdf"*
                      </span>
                    </label>
                    <input
                      name="resolucion"
                      type="text"
                      value={this.props.state.nom_resolucion}
                      disabled={true}
                      placeholder="Subir archivo resolución"
                      className="form-control m-b-5"
                    ></input>
                  </div>
                </div>
                <div className="col-md-2" style={{ marginTop: "1.7%" }}>
                  <div className="form-group">
                    <button
                      type="button"
                      name="b_resolucion"
                      className="btn btn-primary float-right"
                      onClick={(e) => hiddenFileInput_r.current.click()}
                    >
                      Seleccionar archivo
                    </button>
                    <input
                      type="file"
                      accept=".pdf"
                      name="b_resolucion"
                      ref={hiddenFileInput_r}
                      onChange={(e) =>
                        this.props.component.handleFile(1, e.target)
                      }
                      style={{ display: "none" }}
                    />
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="form-group">
                    <button
                      style={{ margin: 10 }}
                      onClick={() => {
                        //MAXIMO DE SANCIONES 2
                        let r_id =
                          this.props.state.regente_id === ""
                            ? "0"
                            : this.props.state.regente_id;

                        let r_nombre = "";
                        for (let r in this.props.state.opciones_regente) {
                          if (
                            this.props.state.opciones_regente[r].id === r_id
                          ) {
                            r_nombre =
                              this.props.state.opciones_regente[r].nombre;
                            break;
                          }
                        }

                        let s_id =
                          this.props.state.tipo_sancion_id === ""
                            ? "0"
                            : this.props.state.tipo_sancion_id;
                        let s_descripcion =
                          document.querySelector("#tipo_sancion").options[
                            parseInt(s_id)
                          ].text;

                        let i_id =
                          this.props.state.tipo_infraccion_id === ""
                            ? "0"
                            : this.props.state.tipo_infraccion_id;
                        let i_descripcion =
                          document.querySelector("#tipo_infraccion").options[
                            parseInt(i_id)
                          ].text;

                        let obj = {
                          regente_id: r_id,
                          regente_nombre: r_nombre,
                          tipo_sancion_id: s_id,
                          tipo_sancion: s_descripcion,
                          tipo_infraccion_id: i_id,
                          tipo_infraccion: i_descripcion,
                          causas_sancion: this.props.state.causas_sancion,
                          monto: this.props.state.monto,
                          //causas_descripcion: "",
                          informe: this.props.state.informe[0],
                          resolucion: this.props.state.resolucion[0],
                        };

                        this.props.component.handleSancion(obj);
                        this.props.component.AddSancionRegente(obj);
                      }}
                      className="btn btn-success float-right"
                    >
                      Agregar sanción
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <hr></hr>
            <div className="table-responsive">
              <table className="table table-striped m-b-0 table-hover">
                <thead>
                  <tr>
                    <th>Regente</th>
                    <th>Sanción</th>
                    <th>Infracción</th>
                    <th>Causa(s) de sanción</th>
                    <th>Monto</th>
                    <th>Informe</th>
                    <th>Resolución</th>
                    <th> </th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.state.sanciones.length > 0 ? (
                    this.props.state.sanciones.map((sanciones, index) => (
                      <tr key={index} id={index}>
                        <td>{sanciones.regente_nombre}</td>
                        <td>{sanciones.tipo_sancion}</td>
                        <td>{sanciones.tipo_infraccion}</td>
                        <td
                          data-toggle="tooltip"
                          data-placement="top"
                          title={sanciones.causas_sancion}
                        >
                          {sanciones.causas_sancion.length > 100
                            ? sanciones.causas_sancion.substring(0, 100) + "..."
                            : sanciones.causas_sancion}
                        </td>
                        <td>
                          {sanciones.monto !== "" ? sanciones.monto : "Ninguno"}
                        </td>
                        <td className="text-center">
                          <button
                            onClick={(e) =>
                              this.props.component.handleVistaPrevia(e)
                            }
                            data-file={sanciones.informe}
                            name="informe"
                            className="btn btn-info"
                            id={index}
                            width="60"
                          >
                            <i
                              className="fa fa-file-pdf"
                              name="informe"
                              id={index}
                            ></i>
                          </button>
                        </td>
                        <td className="text-center">
                          <button
                            onClick={(e) =>
                              this.props.component.handleVistaPrevia(e)
                            }
                            data-file={sanciones.resolucion}
                            className="btn btn-info"
                            name="resolucion"
                            id={index}
                            width="60"
                          >
                            <i
                              className="fa fa-file-pdf"
                              name="resolucion"
                              id={index}
                            ></i>
                          </button>
                        </td>
                        <td className="text-right">
                          <button
                            className="btn btn-warning remover-sancion"
                            id={index}
                            onClick={this.props.component.removeSancion}
                          >
                            <i
                              className="fas fa-trash"
                              id={index}
                              onClick={this.props.component.removeSancion}
                            ></i>
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td className="text-center">No se hay saciones</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </fieldset>
          <hr></hr>
          <fieldset className="panel">
            <legend>
              Observaciones<span className="text-danger"> *</span>{" "}
            </legend>
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="form-group">
                    <textarea
                      className="form-control"
                      placeholder="Observaciones"
                      maxLength={500}
                      rows="5"
                      name="observaciones"
                      value={this.props.state.observaciones}
                      onChange={(e) =>
                        this.props.component.handleObservacionChange(e)
                      }
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
          <hr></hr>
          <div className="btn-group float-right">
            <button
              type="button"
              onClick={() => {
                this.props.component.closeModalSancionReg(1);
              }}
              className="btn btn-danger"
            >
              Regresar
            </button>
            <button
              type="button"
              onClick={() => {
                this.props.component.handleSubmit(1,3);
              }}
              className="btn btn-success"
            >
              Generar sanción
            </button>
          </div>
          <div className={this.props.state.previa ? "previa" : "hide"}>
            <iframe
              title="Vista previa"
              src={`data:application/pdf;base64,${this.props.state.previa_url}`}
              width="100%"
              height="100%"
            ></iframe>
            <center>
              <div className="btn-group">
                <button
                  onClick={(e) => {
                    this.props.component.handleCloseVistaPrevia(e);
                  }}
                  className="btn btn-danger"
                >
                  Regresar
                </button>
              </div>
            </center>
          </div>
        </div>
      </>
    );
  }
}

export default ModalSancionRegente;
